import { Injectable } from '@angular/core';
import { LimitChangesSummary, Limits, LimitsUpdateSummary, LimitType, UpdateLimits } from './player-limits-view.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class PlayerLimitsService {
  NET_LOSS_LIMIT_API_PATH_SUFFIX = 'net-loss-limits';
  DEPOSIT_LIMIT_API_PATH_SUFFIX = 'deposit-limits';
  constructor(private http: HttpClient) {}

  updateMaxLimits(pid: string, update: UpdateLimits, limitType: LimitType): Observable<void> {
    return this.http.put<void>(
      `/player-activity/api/players/${pid}/${this.getLimitApiPathSuffix(limitType)}/max`,
      update
    );
  }

  getPreviewOfMaxLimitsUpdate(
    pid: string,
    update: UpdateLimits,
    limitType: LimitType
  ): Observable<LimitsUpdateSummary> {
    const params = new HttpParams()
      .set('daily', update.daily)
      .set('weekly', update.weekly)
      .set('monthly', update.monthly);
    return this.http.get<LimitsUpdateSummary>(
      `/player-activity/api/players/${pid}/${this.getLimitApiPathSuffix(limitType)}/max/update-preview`,
      { params: params }
    );
  }
  getPreviewOfLimitsUpdate(pid: string, update: UpdateLimits, limitType: LimitType): Observable<LimitsUpdateSummary> {
    const params = new HttpParams()
      .set('daily', update.daily)
      .set('weekly', update.weekly)
      .set('monthly', update.monthly);
    return this.http.get<LimitsUpdateSummary>(
      `/player-activity/api/players/${pid}/${this.getLimitApiPathSuffix(limitType)}/update-preview`,
      {
        params: params,
      }
    );
  }

  updateLimits(pid: string, update: UpdateLimits, limitType: LimitType): Observable<void> {
    return this.http.put<void>(`/player-activity/api/players/${pid}/${this.getLimitApiPathSuffix(limitType)}`, update);
  }

  getLimits(pid: string, limitType: LimitType): Observable<Limits> {
    return this.http.get<Limits>(`/player-activity/api/players/${pid}/${this.getLimitApiPathSuffix(limitType)}`);
  }

  getLimitChangesHistory(playerId: string): Observable<LimitChangesSummary[]> {
    return this.http.get<LimitChangesSummary[]>(`/player-activity/api/players/${playerId}/limits/changes`);
  }

  private getLimitApiPathSuffix(limitType: LimitType) {
    if (limitType === LimitType.DEPOSIT) {
      return this.DEPOSIT_LIMIT_API_PATH_SUFFIX;
    }
    return this.NET_LOSS_LIMIT_API_PATH_SUFFIX;
  }
}
